export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Available time slots (10:00 - 18:00)
export const TIME_SLOTS = [
  "10:00", "11:00", "12:00", "13:00", "14:00", "15:00", "16:00", "17:00"
];

// Status colors and labels
export const STATUS_CONFIG = {
  in_attesa: { label: "In Attesa", color: "bg-amber-100 text-amber-800 border-amber-200" },
  confermato: { label: "Confermato", color: "bg-blue-100 text-blue-800 border-blue-200" },
  completato: { label: "Completato", color: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  annullato: { label: "Annullato", color: "bg-red-100 text-red-800 border-red-200" }
};

// Cascina (PI) center coordinates for default map view
export const CASCINA_CENTER = [43.6762, 10.5520];
export const CASCINA_ZOOM = 13;
